/** @jsxImportSource @emotion/react */
import { Box, IconButton, Modal, Paper, Table, TableContainer } from '@mui/material'
import { GridCloseIcon } from '@mui/x-data-grid'
import React from 'react'
import {
  clickableTableWrapper,
  closeButton,
  enlargedTable,
  modalContainer,
  modalContent,
} from './ArticleTableLightbox.style'

type Props = {
  children: React.ReactNode
  modalMinWidth?: number
  ariaLabel?: string
}

const ArticleTableLightbox: React.FC<Props> = ({
  children,
  modalMinWidth = 900,
  ariaLabel = 'Open table in larger view',
}) => {
  const [open, setOpen] = React.useState(false)

  const openLightbox = () => setOpen(true)
  const closeLightbox = () => setOpen(false)

  const onKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      openLightbox()
    }
  }

  return (
    <>
      <Box
        role="button"
        tabIndex={0}
        aria-haspopup="dialog"
        aria-label={ariaLabel}
        onClick={openLightbox}
        onKeyDown={onKeyDown}
        css={clickableTableWrapper}
      >
        {children}
      </Box>

      <Modal
        open={open}
        onClose={closeLightbox}
        keepMounted
        closeAfterTransition
        slotProps={{ backdrop: { style: { backgroundColor: 'rgba(0,0,0,0.8)' } } }}
      >
        <Box onClick={closeLightbox} role="dialog" aria-modal="true" css={modalContainer}>
          <Box onClick={(e) => e.stopPropagation()} css={modalContent}>
            <IconButton
              onClick={closeLightbox}
              aria-label="Close table"
              size="small"
              css={closeButton}
            >
              <GridCloseIcon />
            </IconButton>

            <TableContainer component={Paper} elevation={0}>
              <Table css={enlargedTable(modalMinWidth)}>{children}</Table>
            </TableContainer>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default ArticleTableLightbox
